import { createContext, useContext } from 'react'

export const sizes = {
  default: 'default',
  nano: 'nano',
  xxs: 'xxs',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl',
} as const

export type Sizes = keyof typeof sizes

type AtSizeFunc = <T, D>({
  default: D,
  nano,
  xxs,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
}: Partial<Record<Exclude<Sizes, 'default'>, T>> & Record<'default', D>) => T | D

const atWidth: (size: Sizes) => AtSizeFunc =
  (size) =>
  ({ default: defaultValue, nano, xxs, xs, sm, md, lg, xl, xxl }) => {
    switch (size) {
      case 'xxl':
        return xxl ?? xl ?? lg ?? md ?? sm ?? xs ?? xxs ?? nano ?? defaultValue
      case 'xl':
        return xl ?? lg ?? md ?? sm ?? xs ?? xxs ?? nano ?? defaultValue
      case 'lg':
        return lg ?? md ?? sm ?? xs ?? xxs ?? nano ?? defaultValue
      case 'md':
        return md ?? sm ?? xs ?? xxs ?? nano ?? defaultValue
      case 'sm':
        return sm ?? xs ?? xxs ?? nano ?? defaultValue
      case 'xs':
        return xs ?? xxs ?? nano ?? defaultValue
      case 'xxs':
        return xxs ?? nano ?? defaultValue
      case 'nano':
        return nano ?? defaultValue
      default:
        return defaultValue
    }
  }

const PageContentWidthContext = createContext<Sizes>('default')

export default PageContentWidthContext

/* useContainerWidth for the whole page excluding info sheet. i.e. use(PageWidth - infoSheetWidth). */
export function useAtPageContentSize(): AtSizeFunc {
  const size = useContext(PageContentWidthContext)
  return atWidth(size)
}
